import { Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { accountApi } from '@/api/account';
import { LanguageChips } from '@/components/LanguageChips';
import { useActionError } from '@/components/useActionError';
import { useToast } from '@/components/useToast';

/**
 * The console language — switched locally at once (the existing preference) and saved to the
 * account with `PATCH /api/account/locale`, so saas-login and emails follow it.
 */
export function LanguageSection() {
  const { t } = useTranslation();
  const toast = useToast();
  const describe = useActionError();

  function save(code: string) {
    accountApi.updateLocale(code).catch((err: unknown) => {
      toast(describe(err).message, 'error');
    });
  }

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography variant="h2" component="h2" sx={{ mb: 0.5 }}>
        {t('account.language.title')}
      </Typography>
      <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
        {t('account.language.lead')}
      </Typography>
      <LanguageChips onChange={save} />
    </Paper>
  );
}
